<template>
  <Layout2 :ratio="'1.05fr 1fr'" id="push-filter">
    <template slot="left">
      <Info :info="info"/>
      <div id="l2">
        <div>推播受眾</div>
        <div class="v2">預計傳送人數 <span>{{usersSelected.length}}</span>人</div>
        <div v-if="available<0" class="error" :style="{marginLeft: 'auto'}">!注意: 您已超過預設上限 {{available*-1}} 人，可能須增加費用或變更減少受眾範圍。</div>
      </div>
      <div class="l3">
        <div class="field">
          <div>傳送時間</div>
          <div :style="{flexDirection: 'column'}">
            <label class="radio"><input type="radio" :value="null" v-model="sendTime">立即傳送</label>
            <div class="flex"><label class="radio"><input type="radio" :value="'指定'" v-model="sendTime"></label>
              <Date :defaultValue="sendDate" @input="sendDate=$event"/>
              <Time :defaultValue="sendTimeT" @input="sendTimeT=$event"></Time>
            </div>
          </div>
        </div>
        <div class="field" label="角色">
          <div>角色</div>
          <div>
            <label class="radio" v-for="rl in rolemap.filter(e => e.type === 'outter')" :key="rl.key"
            ><input type="checkbox"  v-model="role" :value="rl.key">{{rl.zh}}</label>
          </div>
        </div>
        <div class="field">
          <div>性別</div>
          <div>
            <label v-for="(gd, a) in genders" :key="`gender-${a}`" class="radio"
            ><input type="checkbox"  v-model="gender" :value="gd">{{gd}}</label>
          </div>
        </div>
        <div class="field">
          <div>年齡</div>
          <div>
            <label v-for="(ag, a) in ages" :key="`age-${a}`" class="radio widthFixed"
            ><input v-model="age" type="checkbox" :value="ag">{{
              ag[0]===0?`${ag[1]}歲以下`:!ag[1]?`${ag[0]}歲以上`:`${ag[0]}~${ag[1]}歲`
            }}</label>
          </div>
        </div>
        <div class="field">
          <div>地區</div>
          <div>
            <label v-for="(gd, a) in countries" :key="`gd-${a}`" class="radio widthFixed"
            ><input v-model="area" type="checkbox" :value="gd">{{gd}}</label>
          </div>
        </div>
        <div class="field">
          <div>消費條件</div>
          <div :style="{flexDirection: 'column'}">
            <div class="flex"><label class="radio"><input type="radio" v-model="consume" :value="null">無</label></div>
            <div class="flex"><label class="radio"><input type="radio" v-model="consume" :value="'上個月'">上個月消費金額   滿</label>
              <input type="text" :value="dollers1" @change="consume='上個月';dollers1=parseInt($event.target.value||0);" placeholder="2000">元</div>
            <div class="flex"><label class="radio"><input type="radio" v-model="consume" :value="'本年度'">本年度消費金額   滿</label>
              <input type="text" :value="dollers2" @change="consume='本年度';dollers2=parseInt($event.target.value||0);" placeholder="100000">元</div>
            <div class="flex"><label class="radio"><input type="radio" v-model="consume" :value="'去年度'">去年度消費金額   滿</label>
              <input type="text" :value="dollers3" @change="consume='去年度';dollers3=parseInt($event.target.value||0);" placeholder="100000">元</div>
          </div>
        </div>
      </div>
    </template>
    <Box @save="save" @saveAs="save($event, true)" :clear="clear" :processing="processing"/>
  </Layout2>
</template>

<script>
import Date from '../../components/input/date.vue'
import Time from '../../components/input/time.vue'
import Layout2 from '../../components/layout/La1.vue'
import { mapState } from 'vuex'
import { getapi, putapi } from '../../store/fetch'
import Box from './message/box.vue'
import Info from './message/lineinfobox.vue'
export default {
  props: ['info'],
  components: {
    Box,
    Info,
    Date,
    Time,
    Layout2
  },
  data () {
    return {
      clear: 0,
      dollers1: null,
      dollers2: null,
      dollers3: null,
      sendTime: null,
      sendTimeT: null,
      sendDate: null,
      consume: null,
      processing: false,
      role: [],
      age: [],
      area: [],
      gender: [],
      countries: [],
      genders: ['男', '女', '不透漏'],
      ages: [[0, 14], [15, 19], [20, 29], [30, 39], [40, 49], [50, 59], [60, 64], [65]],
      usersSelected: []
    }
  },
  async mounted () {
    this.countries = await getapi('selections/country')
    await this.getUsers()
  },
  computed: {
    available () {
      return ((this.info.limitMax || 500) - (this.info.countUsed || 0)) - this.usersSelected.length
    },
    id () {
      return this.$route.query.id
    },
    ...mapState({
      rolemap: 'rolemap'
    })
  },
  watch: {
    id: {
      async handler () {
        if (!this.id) {
          return false
        }
        const { targetFilters: data } = await getapi(`message/${this.id}`)
        this.role = data.role || []
        this.area = data.country || []
        this.age = data.age || []
        this.gender = data.gender || []
        this.consume = data.consume === '無' ? null : data.consume
        this.consumeNumber = data.consumeNumber
        await this.getUsers()
      },
      immediate: true
    },
    role () { this.getUsers() },
    consume () { this.getUsers() },
    dollers1 () { this.getUsers() },
    dollers2 () { this.getUsers() },
    dollers3 () { this.getUsers() },
    area () { this.getUsers() },
    age () { this.getUsers() },
    gender () { this.getUsers() },
    sendDate () { this.sendTime = '指定' },
    sendTimeT () { this.sendTime = '指定' }
  },
  methods: {
    async save (ev, temp) {
      this.processing = true
      await this.wait(100)
      let type
      const content = {}
      switch (ev.messageType) {
        case '活動公告':
          switch (ev.type) {
            case '純文字':
              type = 'text'
              content.textContent = ev.content
              break
            case '純圖片':
              type = 'image'
              content.imageUrl = ev.content
              break
            case '圖文訊息':
              type = 'bubble'
              content.bubbleHeader = ev.content.title
              content.bubbleContent = ev.content.content
              content.bubbleImage = `${ev.content.image}`
              content.bubbleLink = ev.content.link
              break
          }
          break
        case '發送票券':
          type = 'coupon'
          content.coupon = ev.coupon._id
          break
        case '發送多張票券':
          type = 'multicoupons'
          content.coupons = ev.coupons.map(e => { return { ...e, coupon: e.coupon._id } })
          break
        case '發送票券並推播':
          switch (ev.type) {
            case '純文字':
              type = 'couponWithText'
              content.coupon = ev.coupon._id
              content.textContent = ev.content
              break
            case '純圖片':
              type = 'couponWithImage'
              content.coupon = ev.coupon._id
              content.imageUrl = ev.content
              break
          }
          break
        default:
          alert('ERROR')
          break
      }
      const url = `message/${type}${temp ? '/temp' : ''}`
      const targetFilters = this.getfilters({})
      const to = ev.messageType === '活動公告' ? this.usersSelected.map(e => e.lineID) : this.usersSelected.map(e => e._id)
      if ((this.usersSelected?.length || 0) === 0) {
        alert('所選無客戶')
        console.log(url, { ...content, type, targetFilters, to, sendTime: this.sendTime ? this.moment(`${this.sendDate} ${this.sendTimeT}`).toISOString() : '' })
        return false
      }
      const r = await putapi(url, { ...content, type, targetFilters, to, sendTime: this.sendTime ? this.moment(`${this.sendDate} ${this.sendTimeT}`).toISOString() : '' })
      if (r) {
        alert(temp ? '儲存成功' : '發送成功')
        this.clear += 1
        this.tagsSeleted = []
        this.usersSelected = []
      }
      this.processing = false
    },
    getfilters (ev) {
      const params = ev
      if (this.role && this.role.length > 0) params.role = this.role
      if (this.area && this.area.length > 0) params.country = this.area
      if (this.gender && this.gender.length > 0) params.gender = this.gender
      if (this.age && this.age.length > 0) {
        console.log(this.age)
        const age = this.age.map(e => Object.assign({}, ...e.map((a, i) => { return { [i === 0 ? '$gte' : '$lte']: a } })))
        age.sort((a, b) => a.$gte - b.$gte)
        params.age = JSON.stringify(age)
      }
      if (this.consume) {
        switch (this.consume) {
          case '上個月':
            params.consumeNumber = (this.dollers1 || 2000)
            params.consume = '上個月消費金額'
            break
          case '本年度':
            params.consumeNumber = (this.dollers2 || 10000)
            params.consume = '本年度消費金額'
            break
          case '去年度':
            params.consumeNumber = (this.dollers3 || 10000)
            params.consume = '去年度消費金額'
            break
        }
      }
      return params
    },
    async getUsers () {
      const params = this.getfilters({ scope: ['lineID', '_id'] })
      const { data } = await getapi('users/line?' + new URLSearchParams(params))
      this.usersSelected = data
    }
  }

}
</script>

<style lang="scss">
#push-filter {
  .La1_left {
    border-right: 1px solid #CACACA;
    overflow-y: auto;
    padding: 18px 34px 38px;
  }
  .La1_right {
    overflow-y: auto;
  }
  .field-input {
    border-color: #CACACA!important;
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}
.l3 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 46px;
  .field {
    display: flex;
    align-items: flex-start;
    gap: 23px;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    text-align: right;
    letter-spacing: 0.1em;
    color: #787878;
    &>div:nth-child(1){
      width: 120px;
      min-width: 120px;
      text-align: end;
      height: 27px;
    }
    &>div:nth-child(2) {
      display: flex;
      text-align: start;
      flex-wrap: wrap;
      gap: 23px;
    }
    input[type=text] {
      width: 105px;
      height: 40px;
      border: 1px solid #B9B9B9;
      border-radius: 3px;
      font-weight: 400;
      font-size: 18px;
      line-height: 21px;
      text-align: center;
      letter-spacing: 0.1em;
    }
  }
}
label.radio {
  display: inline-flex;
  flex-wrap: nowrap;
  text-align: start;
  align-items: center;
  justify-content: flex-start;
  height: 27px;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1em;
  color: #787878;
  gap: 8px;
  &.widthFixed {
    width: 125px;
    min-width: 125px;
  }
  input[type=checkbox], input[type=radio] {
    appearance: none;
    width: 24px;
    height: 24px;
    border: 2px solid var(--color-pri);
    border-radius: 12px;
    &:checked {
      background-color: var(--color-checked);
      background-image: url(/checked.svg);
      background-position: center;
      background-repeat: no-repeat;
      background-size: 24px;
    }
  }
}
#l2 {
  display: flex;
  margin-block: 16px 11px;
  align-items: center;
  font-weight: 400;
  font-size: 25px;
  line-height: 36px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  gap: 5px;
  white-space: nowrap;
  position: relative;
  .v2 {
    margin-left: auto;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1em;
    color: #787878;
    span {
      color: #FF7373;
      margin-inline: 1em;
    }
  }
  .error {
    top: 32px;
    position: absolute;
    right: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: right;
    letter-spacing: 0.1em;
    color: #FF7373;
  }
}
</style>
